import { Popover as ChakraPopover, PopoverProps as ChakraPopoverProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

export type PopoverProps = ChakraPopoverProps;

const propTypes = {
  autoFocus: PropTypes.bool,
  isOpen: PropTypes.bool,
  defaultIsOpen: PropTypes.bool,
  isLazy: PropTypes.bool,
  closeOnEsc: PropTypes.bool
};
const defaultProps = {
  closeOnEsc: true,
  isOpen: undefined,
  defaultIsOpen: undefined,
  isLazy: true,
  autoFocus: false
};
export default function Popover(props: ChakraPopoverProps): React.ReactElement {
  return <ChakraPopover {...props} />;
}

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
